export default function WhatsAppButton() {
  const phoneNumber = '690220944';
  const message = encodeURIComponent('Hola, me gustaría solicitar información sobre sus servicios de limpieza y restauración post incendio.');

  return (
    <a
      href={`https://wa.me/34${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-110 flex items-center justify-center cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </a>
  );
}